import api from './api';
import { SystemStats, SystemHealth } from '../types';
import { demoDataService } from './demoDataService';
import { config } from '../config';

export const systemApi = {
  // Get system statistics
  getSystemStats: async (): Promise<SystemStats> => {
    if (config.shouldUseDemoMode()) {
      return demoDataService.getSystemStats();
    }
    
    try {
      const response = await api.get('/admin/stats');
      return response.data;
    } catch (error: any) {
      console.warn('Backend not available, falling back to demo mode');
      return demoDataService.getSystemStats();
    }
  },

  // Get system health
  getSystemHealth: async (): Promise<SystemHealth> => {
    if (config.shouldUseDemoMode()) {
      return demoDataService.getSystemHealth();
    }
    
    try {
      const response = await api.get('/admin/health');
      return response.data;
    } catch (error: any) {
      console.warn('Backend not available, falling back to demo mode');
      return demoDataService.getSystemHealth();
    }
  },

  // Get public system status
  getPublicStatus: async (): Promise<any> => {
    const response = await api.get('/public/status');
    return response.data;
  },

  // Get public health check
  getPublicHealth: async (): Promise<any> => {
    const response = await api.get('/public/health');
    return response.data;
  },
};
